<!-- 收货人信息table -->
<template>
    <el-dialog append-to-body title="已有收获地址" :visible.sync="centerDialogVisible" width="50%">
        <el-table  border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" :data="tableData" style="width: 100%">
            <el-table-column  width="50px" label="选择" align="center">
                <template slot-scope="scope">
                    <el-radio  :label="scope.row.id" v-model="radio"
                        @change.native="handleSelectionChange(scope.$index, scope.row)">&nbsp</el-radio>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="userName" width="100" label="收货人姓名">
            </el-table-column>
            <el-table-column align="center" prop="companyName" width="100" label="公司">
            </el-table-column>
            <el-table-column align="center" prop="userPhone" width="100" label="手机号码">
            </el-table-column>
            <el-table-column align="center" prop="address" label="收货地址">
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save()">确 定</el-button>
            <el-button @click="centerDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import Api from '@/components/Api/index'
export default {
    components: {
    },
    data() {
        return {
            tableData: [],
            radio: "",
            rowInfo: {},
            centerDialogVisible: false,
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick() {
            this.radio = ''
            this.rowInfo = {}
            this.queryAllAddressList()
            this.centerDialogVisible = true
        },
        handleSelectionChange(index, row) {
            this.rowInfo = row
        },
        //保存
        save() {
            if(JSON.stringify(this.rowInfo) !== '{}') {
                 this.$emit('addressInfoClick',this.rowInfo)
            }
            this.centerDialogVisible = false
        },
        //查询收货人列表
        queryAllAddressList() {
            new Api("user")
                .queryAllAddress()
                .then((res) => {
                    if (res.status == 200) {
                        this.tableData = res.data
                    } else {
                        this.$message.error({ message: res.statusText });
                    }
                });
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>
